import React from "react";
import { Grid } from "@material-ui/core";
import classnames from "classnames";
import { ArrowForward as ArrowForwardIcon } from "@material-ui/icons";

// styles
import useStyles from "./styles";

// components
import Widget from "../../Widget/Widget";
import { Typography } from "../../Wrappers/Wrappers";

export default function TileComparative(props) {
  var { product, today, yesterday, monthly, weekly, isAvg, isCurrency,
        product2, today2, yesterday2, monthly2, weekly2 } = props;
  var classes = useStyles();
  if(today === undefined){
    return (<></>)
  }

  return (
    <Widget header={
      <div>
        <Typography variant="h5">{product} x {product2}</Typography>
      </div>
    }
    upperTitle >
      
      <Typography variant="h5">{product} x {product2}</Typography>
      <div className={classes.totalValueContainer}>
        
        <div className={classes.totalValue}>
          <Typography size="xxl" color="text" colorBrightness="secondary">
            {(isCurrency ? `$${today.value}`: today.value)} x {(isCurrency ? `$${today2.value}`: today2.value)}
          </Typography>
          {/* {getArrow(isRaw ? todayRaw : today.value, isRaw ? yesterdayRaw : yesterday.value)} */}
          <Typography color={"primary"}>
            Today
          </Typography>
        </div>
      </div>
      <div className={classes.bottomStatsContainer}>
        <div className={classnames(classes.statCell, classes.borderRight)}>
          <Grid container alignItems="center">
            <Typography variant="h6">{(isCurrency ? `$${yesterday.value}`: yesterday.value)} x {(isCurrency ? `$${yesterday2.value}`: yesterday2.value)}</Typography>
            {(isAvg ? getArrow(yesterday.value,weekly.value):<></>)}
          </Grid>
          <Typography size="sm" color="text" colorBrightness="secondary">
            Yesterday
          </Typography>
        </div>
        <div className={classes.statCell}>
          <Grid container alignItems="center">
            <Typography variant="h6">{(isCurrency ? `$${weekly.value}`: weekly.value)} x {(isCurrency ? `$${weekly2.value}`: weekly2.value)}</Typography>
            {/* {(isAvg ? getArrow(weekly.value,monthly.value):<></>)} */}
          </Grid>
          <Typography size="sm" color="text" colorBrightness="secondary">
            Last 7 days
          </Typography>
        </div>
        <div className={classnames(classes.statCell, classes.borderRight)}>
          <Grid container alignItems="center">
            <Typography variant="h6">
            {(isCurrency ? `$${monthly.value}`: monthly.value)} x {(isCurrency ? `$${monthly2.value}`: monthly2.value)}
            </Typography>
          </Grid>
          <Typography size="sm" color="text" colorBrightness="secondary">
            Last 30 days
          </Typography>
        </div>
      </div>
    </Widget>
  );

  function getArrow(firstValue, valueToCompare) {
    return <ArrowForwardIcon className={(parseFloat(firstValue) > parseFloat(valueToCompare) ? classnames(classes.profitArrow) : firstValue !== valueToCompare ? classnames(classes.profitArrowDanger) : classnames())} />;
  }
}
